<div class="fragrance-catalogue">
    <app-gradient class="gradient gradient__left"></app-gradient>
    <app-gradient class="gradient gradient__right"></app-gradient>
    <div class="fragrance-catalogue__container-header">
        <a [routerLink]="['/']" class="body-m">{{ 'fragrance-catalogue.home' | translate }}</a>
        <span class="body-m">/</span>
        <span class="body-m">{{ 'fragrance-catalogue.title' | translate }}</span>
    </div>
    <a 
      [routerLink]="['/']" class="back-to-home body-s">
      <mat-icon class="back-to-home-icon" svgIcon="arrow-back-orange"></mat-icon>
      {{ 'fragrance-catalogue.home' | translate }}
    </a>
    <section class="fragrance-catalogue__container">
      <div class="fragrance-catalogue__container-content">
        <div class="fragrance-catalogue__filters">
          <span class="heading-s">
            {{ 'fragrance-catalogue.filters' | translate }}
          </span>
        </div>
        <section class="fragrance-catalogue__content">
          <div class="fragrance-catalogue__content-heading">
            <span class="heading-s">
              {{ 'fragrance-catalogue.title' | translate }}
            </span>
            <span class="body-l text-dark-alt">{{ 'fragrance-catalogue.product-count' | translate : { count: fragranceCatalogService.products().length } }}</span>
          </div>
          <div class="fragrance-catalogue__list">
            @for (product of fragranceCatalogService.catalog()?.data; track product) {
                <app-fragrance-catalog-product-card 
                  [product]="product"
                  (cardClick)="goToDetail(product.id)">
                </app-fragrance-catalog-product-card>
            }
          </div>
          @if ((fragranceCatalogService.catalog()?.pagination?.totalPage ?? 0) > 1) {
            <app-pagination [currentPage]="currentPage" [totalPages]="fragranceCatalogService.catalog()?.pagination?.totalPage ?? 0" (pageChange)="onPageChange($event)"></app-pagination>
          }
        </section>
      </div>
    </section>
  </div>
  